import React, { Suspense } from 'react'
import { Outlet } from "react-router-dom"
import Loader from '../common/Loader'
import { Col, Container, Row } from 'react-bootstrap'
import "./layout.css"
// import Sidebar from '../components/naviagation/Sidebar'
import Topnav from '../components/naviagation/Topnav'
import Footer from '../components/naviagation/Footer'
import ScrollToTop from '../pages/ScrollToTop'

function Layout() {
    return (
        <Container fluid>
            <ScrollToTop>
                <Row>
                    {/* <Col>
                    <Sidebar />
                </Col> */}
                    <Col className='p-0'>
                        <Topnav />
                    </Col>
                </Row>
                <Container className='mb-5 mt-5'>
                    <Row>
                        <Col>
                            <main>
                                <Suspense fallback={<Loader />}>
                                    <Outlet />
                                </Suspense>
                            </main>
                        </Col>
                    </Row>
                </Container>
                <Row>
                    <Col className='p-0'>
                        <Footer />
                    </Col>
                </Row>
            </ScrollToTop>
        </Container>
    )
}

export default Layout